import React, { useState } from "react";
import { Cadet } from "../../shared/types/scoreboard.types";
import { Close } from "@mui/icons-material";
import { Drawer, Box, Typography, FormControlLabel, Switch, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { RenderDetailsContent } from "./RenderDetailsContent";
import { on } from "events";

interface DesktopDrawerComponentProps {
  selectedCadet: Cadet | null;
  onCloseDrawer: () => void;
  permanentDrawer: boolean;
  setPermanentDrawer: (value: boolean) => void;
}

export const DesktopDrawerComponent: React.FC<DesktopDrawerComponentProps> = ({
  selectedCadet,
  onCloseDrawer,
  permanentDrawer,
  setPermanentDrawer,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleCloseDrawer = () => {
    onCloseDrawer();
  };

  return (
    <div>
      {!isMobile && Boolean(selectedCadet) && (
        <Drawer
          variant={!isMobile && permanentDrawer ? "permanent" : "temporary"}
          anchor={isMobile ? "bottom" : "right"}
          open={isMobile ? Boolean(selectedCadet) : true}
          onClose={handleCloseDrawer}
          sx={{
            "& .MuiDrawer-paper": {
              width: isMobile ? "100%" : "30vw", // Fixed width for permanent drawer
              height: isMobile ? "70vh" : "100%",
              boxSizing: "border-box",
              padding: theme.spacing(3),
            },
          }}
        >
          {/* Drawer Header with Toggle and Close Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              borderBottom: `1px solid ${theme.palette.divider}`,
              position: "sticky",
              top: 0,
              bgcolor: "background.paper",
              zIndex: 1,
            }}
          >
            <Typography variant="h6">{(selectedCadet && selectedCadet.primaryCadet) || "Details"}</Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {!isMobile && (
                <FormControlLabel
                  control={
                    <Switch size="small" checked={permanentDrawer} onChange={() => setPermanentDrawer(!permanentDrawer)} color="primary" />
                  }
                  label="Pin"
                  labelPlacement="start"
                  sx={{ mr: 0 }}
                />
              )}
              {(!permanentDrawer || isMobile) && (
                <IconButton onClick={handleCloseDrawer} size="small">
                  <Close fontSize="small" />
                </IconButton>
              )}
            </Box>
          </Box>

          {/* Drawer Content */}
          <Box sx={{ p: 2, overflow: "auto", height: "calc(100% - 64px)" }}>
            {selectedCadet && <>{selectedCadet && <RenderDetailsContent selectedCadet={selectedCadet} />}</>}
          </Box>
        </Drawer>
      )}
    </div>
  );
};
